import { render } from "./AposStylesBody.vue?vue&type=template&id=a3385d60&scoped=true"
import script from "./AposStylesBody.vue?vue&type=script&setup=true&lang=js"
export * from "./AposStylesBody.vue?vue&type=script&setup=true&lang=js"

import "./AposStylesBody.vue?vue&type=style&index=0&id=a3385d60&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3385d60"],['__file',"styles/ui/apos/components/AposStylesBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a3385d60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a3385d60', __exports__)) {
    api.reload('a3385d60', __exports__)
  }
  
  module.hot.accept("./AposStylesBody.vue?vue&type=template&id=a3385d60&scoped=true", () => {
    api.rerender('a3385d60', render)
  })

}


export default __exports__